import { useCurrentUserQuery } from "@graphql/users/users.g";

export const useUserRole = () => {
  const currentUserQuery = useCurrentUserQuery();
  const user = currentUserQuery.data?.currentUser;

  const hasAffireAdminRole = () => {
    return user?.roles?.includes("affire_admin") ?? false;
  };

  return {
    hasAffireAdminRole,
    isLoading: currentUserQuery.isLoading,
  };
};